import styled from 'styled-components';
import { Chip } from '../../../../../components/common/chip/Chip';

export const Benefit = () => {
  return (
    <FeatureDescriptionSectionContainer>
      <ChipContainer>
        <Chip
          type={'round'}
          theme={'strong'}
          color={'white'}
          size={'lg'}
          icon={{ name: 'Check', position: 'left', size: 'Large', fill: '#34C77E' }}
        >
          {'등록비 면제'}
        </Chip>
        <Chip
          type={'round'}
          theme={'strong'}
          color={'white'}
          size={'lg'}
          icon={{ name: 'Check', position: 'left', size: 'Large', fill: '#34C77E' }}
        >
          {'매물 홍보 무료'}
        </Chip>
      </ChipContainer>
    </FeatureDescriptionSectionContainer>
  );
};

const FeatureDescriptionSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--radius-large, 16px);
`;

const ChipContainer = styled.div`
  display: flex;
  width: 224px;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
`;
